// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths, splitProjectFullPath } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/admin/registrations/groups(.:format)`
 * - Path helper: `admin_registrations_groups_path`
 * - URL helper: `admin_registrations_groups_url`
 * - controller#action: `admin/registrations/groups#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRegistrationsGroupsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminRegistrationsGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminRegistrationsGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminRegistrationsGroupsPath(gon.current_organization.path, ...args);
  }

  return _adminRegistrationsGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/registrations/groups/new(.:format)`
 * - Path helper: `new_admin_registrations_group_path`
 * - URL helper: `new_admin_registrations_group_url`
 * - controller#action: `admin/registrations/groups#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminRegistrationsGroupPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminRegistrationsGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _newAdminRegistrationsGroupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminRegistrationsGroupPath(gon.current_organization.path, ...args);
  }

  return _newAdminRegistrationsGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/registrations/profile/skip(.:format)`
 * - Path helper: `skip_admin_registrations_profile_path`
 * - URL helper: `skip_admin_registrations_profile_url`
 * - controller#action: `admin/registrations/profiles#skip`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipAdminRegistrationsProfilePath = /*#__PURE__*/ (...args) => {
  const _skipOrganizationAdminRegistrationsProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _skipAdminRegistrationsProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _skipOrganizationAdminRegistrationsProfilePath(gon.current_organization.path, ...args);
  }

  return _skipAdminRegistrationsProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/registrations/profile/new(.:format)`
 * - Path helper: `new_admin_registrations_profile_path`
 * - URL helper: `new_admin_registrations_profile_url`
 * - controller#action: `admin/registrations/profiles#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminRegistrationsProfilePath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminRegistrationsProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _newAdminRegistrationsProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminRegistrationsProfilePath(gon.current_organization.path, ...args);
  }

  return _newAdminRegistrationsProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/registrations/profile(.:format)`
 * - Path helper: `admin_registrations_profile_path`
 * - URL helper: `admin_registrations_profile_url`
 * - controller#action: `admin/registrations/profiles#update`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRegistrationsProfilePath = /*#__PURE__*/ (...args) => {
  const _organizationAdminRegistrationsProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminRegistrationsProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminRegistrationsProfilePath(gon.current_organization.path, ...args);
  }

  return _adminRegistrationsProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:user_id/keys/:id(.:format)`
 * - Path helper: `admin_user_key_path`
 * - URL helper: `admin_user_key_url`
 * - controller#action: `admin/keys#show`
 *
 * @param {any} userId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserKeyPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminUserKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _adminUserKeyPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminUserKeyPath(gon.current_organization.path, ...args);
  }

  return _adminUserKeyPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:user_id/identities(.:format)`
 * - Path helper: `admin_user_identities_path`
 * - URL helper: `admin_user_identities_url`
 * - controller#action: `admin/identities#index`
 *
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserIdentitiesPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminUserIdentitiesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _adminUserIdentitiesPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminUserIdentitiesPath(gon.current_organization.path, ...args);
  }

  return _adminUserIdentitiesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:user_id/identities/new(.:format)`
 * - Path helper: `new_admin_user_identity_path`
 * - URL helper: `new_admin_user_identity_url`
 * - controller#action: `admin/identities#new`
 *
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminUserIdentityPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminUserIdentityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newAdminUserIdentityPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminUserIdentityPath(gon.current_organization.path, ...args);
  }

  return _newAdminUserIdentityPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:user_id/identities/:id/edit(.:format)`
 * - Path helper: `edit_admin_user_identity_path`
 * - URL helper: `edit_admin_user_identity_url`
 * - controller#action: `admin/identities#edit`
 *
 * @param {any} userId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminUserIdentityPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminUserIdentityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editAdminUserIdentityPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminUserIdentityPath(gon.current_organization.path, ...args);
  }

  return _editAdminUserIdentityPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:user_id/identities/:id(.:format)`
 * - Path helper: `admin_user_identity_path`
 * - URL helper: `admin_user_identity_url`
 * - controller#action: `admin/identities#update`
 *
 * @param {any} userId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserIdentityPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminUserIdentityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _adminUserIdentityPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminUserIdentityPath(gon.current_organization.path, ...args);
  }

  return _adminUserIdentityPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:user_id/impersonation_tokens/:id/revoke(.:format)`
 * - Path helper: `revoke_admin_user_impersonation_token_path`
 * - URL helper: `revoke_admin_user_impersonation_token_url`
 * - controller#action: `admin/impersonation_tokens#revoke`
 *
 * @param {any} userId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeAdminUserImpersonationTokenPath = /*#__PURE__*/ (...args) => {
  const _revokeOrganizationAdminUserImpersonationTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"impersonation_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _revokeAdminUserImpersonationTokenPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"impersonation_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _revokeOrganizationAdminUserImpersonationTokenPath(gon.current_organization.path, ...args);
  }

  return _revokeAdminUserImpersonationTokenPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:user_id/impersonation_tokens/:id/rotate(.:format)`
 * - Path helper: `rotate_admin_user_impersonation_token_path`
 * - URL helper: `rotate_admin_user_impersonation_token_url`
 * - controller#action: `admin/impersonation_tokens#rotate`
 *
 * @param {any} userId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rotateAdminUserImpersonationTokenPath = /*#__PURE__*/ (...args) => {
  const _rotateOrganizationAdminUserImpersonationTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"impersonation_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _rotateAdminUserImpersonationTokenPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"impersonation_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _rotateOrganizationAdminUserImpersonationTokenPath(gon.current_organization.path, ...args);
  }

  return _rotateAdminUserImpersonationTokenPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:user_id/impersonation_tokens(.:format)`
 * - Path helper: `admin_user_impersonation_tokens_path`
 * - URL helper: `admin_user_impersonation_tokens_url`
 * - controller#action: `admin/impersonation_tokens#index`
 *
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserImpersonationTokensPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminUserImpersonationTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"impersonation_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _adminUserImpersonationTokensPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"impersonation_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminUserImpersonationTokensPath(gon.current_organization.path, ...args);
  }

  return _adminUserImpersonationTokensPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/projects(.:format)`
 * - Path helper: `projects_admin_user_path`
 * - URL helper: `projects_admin_user_url`
 * - controller#action: `admin/users#projects`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectsAdminUserPath = /*#__PURE__*/ (...args) => {
  const _projectsOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _projectsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _projectsOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _projectsAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/keys(.:format)`
 * - Path helper: `keys_admin_user_path`
 * - URL helper: `keys_admin_user_url`
 * - controller#action: `admin/users#keys`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const keysAdminUserPath = /*#__PURE__*/ (...args) => {
  const _keysOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _keysAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _keysOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _keysAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/block(.:format)`
 * - Path helper: `block_admin_user_path`
 * - URL helper: `block_admin_user_url`
 * - controller#action: `admin/users#block`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blockAdminUserPath = /*#__PURE__*/ (...args) => {
  const _blockOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _blockAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _blockOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _blockAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/unblock(.:format)`
 * - Path helper: `unblock_admin_user_path`
 * - URL helper: `unblock_admin_user_url`
 * - controller#action: `admin/users#unblock`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unblockAdminUserPath = /*#__PURE__*/ (...args) => {
  const _unblockOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unblock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _unblockAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unblock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _unblockOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _unblockAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/ban(.:format)`
 * - Path helper: `ban_admin_user_path`
 * - URL helper: `ban_admin_user_url`
 * - controller#action: `admin/users#ban`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const banAdminUserPath = /*#__PURE__*/ (...args) => {
  const _banOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _banAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _banOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _banAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/unban(.:format)`
 * - Path helper: `unban_admin_user_path`
 * - URL helper: `unban_admin_user_url`
 * - controller#action: `admin/users#unban`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unbanAdminUserPath = /*#__PURE__*/ (...args) => {
  const _unbanOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _unbanAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _unbanOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _unbanAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/deactivate(.:format)`
 * - Path helper: `deactivate_admin_user_path`
 * - URL helper: `deactivate_admin_user_url`
 * - controller#action: `admin/users#deactivate`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivateAdminUserPath = /*#__PURE__*/ (...args) => {
  const _deactivateOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _deactivateAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _deactivateOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _deactivateAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/activate(.:format)`
 * - Path helper: `activate_admin_user_path`
 * - URL helper: `activate_admin_user_url`
 * - controller#action: `admin/users#activate`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateAdminUserPath = /*#__PURE__*/ (...args) => {
  const _activateOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _activateAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _activateOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _activateAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/unlock(.:format)`
 * - Path helper: `unlock_admin_user_path`
 * - URL helper: `unlock_admin_user_url`
 * - controller#action: `admin/users#unlock`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlockAdminUserPath = /*#__PURE__*/ (...args) => {
  const _unlockOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _unlockAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _unlockOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _unlockAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/confirm(.:format)`
 * - Path helper: `confirm_admin_user_path`
 * - URL helper: `confirm_admin_user_url`
 * - controller#action: `admin/users#confirm`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmAdminUserPath = /*#__PURE__*/ (...args) => {
  const _confirmOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _confirmAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _confirmOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _confirmAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/approve(.:format)`
 * - Path helper: `approve_admin_user_path`
 * - URL helper: `approve_admin_user_url`
 * - controller#action: `admin/users#approve`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveAdminUserPath = /*#__PURE__*/ (...args) => {
  const _approveOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _approveAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _approveOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _approveAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/trust(.:format)`
 * - Path helper: `trust_admin_user_path`
 * - URL helper: `trust_admin_user_url`
 * - controller#action: `admin/users#trust`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trustAdminUserPath = /*#__PURE__*/ (...args) => {
  const _trustOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trust"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _trustAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trust"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _trustOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _trustAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/untrust(.:format)`
 * - Path helper: `untrust_admin_user_path`
 * - URL helper: `untrust_admin_user_url`
 * - controller#action: `admin/users#untrust`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const untrustAdminUserPath = /*#__PURE__*/ (...args) => {
  const _untrustOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"untrust"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _untrustAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"untrust"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _untrustOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _untrustAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/reject(.:format)`
 * - Path helper: `reject_admin_user_path`
 * - URL helper: `reject_admin_user_url`
 * - controller#action: `admin/users#reject`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectAdminUserPath = /*#__PURE__*/ (...args) => {
  const _rejectOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _rejectAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _rejectOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _rejectAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/impersonate(.:format)`
 * - Path helper: `impersonate_admin_user_path`
 * - URL helper: `impersonate_admin_user_url`
 * - controller#action: `admin/users#impersonate`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impersonateAdminUserPath = /*#__PURE__*/ (...args) => {
  const _impersonateOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _impersonateAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _impersonateOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _impersonateAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/disable_two_factor(.:format)`
 * - Path helper: `disable_two_factor_admin_user_path`
 * - URL helper: `disable_two_factor_admin_user_url`
 * - controller#action: `admin/users#disable_two_factor`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disableTwoFactorAdminUserPath = /*#__PURE__*/ (...args) => {
  const _disableTwoFactorOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_two_factor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _disableTwoFactorAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_two_factor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _disableTwoFactorOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _disableTwoFactorAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/remove/:email_id(.:format)`
 * - Path helper: `remove_email_admin_user_path`
 * - URL helper: `remove_email_admin_user_url`
 * - controller#action: `admin/users#remove_email`
 *
 * @param {any} id
 * @param {any} emailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeEmailAdminUserPath = /*#__PURE__*/ (...args) => {
  const _removeEmailOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[2,[7,"/"],[2,[3,"email_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _removeEmailAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[2,[7,"/"],[2,[3,"email_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _removeEmailOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _removeEmailAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users(.:format)`
 * - Path helper: `admin_users_path`
 * - URL helper: `admin_users_url`
 * - controller#action: `admin/users#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUsersPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminUsersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminUsersPath(gon.current_organization.path, ...args);
  }

  return _adminUsersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/new(.:format)`
 * - Path helper: `new_admin_user_path`
 * - URL helper: `new_admin_user_url`
 * - controller#action: `admin/users#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminUserPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _newAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id/edit(.:format)`
 * - Path helper: `edit_admin_user_path`
 * - URL helper: `edit_admin_user_url`
 * - controller#action: `admin/users#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminUserPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _editAdminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/users/:id(.:format)`
 * - Path helper: `admin_user_path`
 * - URL helper: `admin_user_url`
 * - controller#action: `admin/users#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminUserPath(gon.current_organization.path, ...args);
  }

  return _adminUserPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/session/destroy(.:format)`
 * - Path helper: `destroy_admin_session_path`
 * - URL helper: `destroy_admin_session_url`
 * - controller#action: `admin/sessions#destroy`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAdminSessionPath = /*#__PURE__*/ (...args) => {
  const _destroyOrganizationAdminSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _destroyAdminSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _destroyOrganizationAdminSessionPath(gon.current_organization.path, ...args);
  }

  return _destroyAdminSessionPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/session/new(.:format)`
 * - Path helper: `new_admin_session_path`
 * - URL helper: `new_admin_session_url`
 * - controller#action: `admin/sessions#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminSessionPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminSessionPath(gon.current_organization.path, ...args);
  }

  return _newAdminSessionPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/session(.:format)`
 * - Path helper: `admin_session_path`
 * - URL helper: `admin_session_url`
 * - controller#action: `admin/sessions#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSessionPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminSessionPath(gon.current_organization.path, ...args);
  }

  return _adminSessionPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/impersonation(.:format)`
 * - Path helper: `admin_impersonation_path`
 * - URL helper: `admin_impersonation_url`
 * - controller#action: `admin/impersonations#destroy`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminImpersonationPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminImpersonationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"impersonation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminImpersonationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"impersonation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminImpersonationPath(gon.current_organization.path, ...args);
  }

  return _adminImpersonationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/initial_setup/new(.:format)`
 * - Path helper: `new_admin_initial_setup_path`
 * - URL helper: `new_admin_initial_setup_url`
 * - controller#action: `admin/initial_setup#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminInitialSetupPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminInitialSetupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"initial_setup"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminInitialSetupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"initial_setup"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminInitialSetupPath(gon.current_organization.path, ...args);
  }

  return _newAdminInitialSetupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/initial_setup(.:format)`
 * - Path helper: `admin_initial_setup_path`
 * - URL helper: `admin_initial_setup_url`
 * - controller#action: `admin/initial_setup#update`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInitialSetupPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminInitialSetupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"initial_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminInitialSetupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"initial_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminInitialSetupPath(gon.current_organization.path, ...args);
  }

  return _adminInitialSetupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/abuse_reports/:id/moderate_user(.:format)`
 * - Path helper: `moderate_user_admin_abuse_report_path`
 * - URL helper: `moderate_user_admin_abuse_report_url`
 * - controller#action: `admin/abuse_reports#moderate_user`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moderateUserAdminAbuseReportPath = /*#__PURE__*/ (...args) => {
  const _moderateUserOrganizationAdminAbuseReportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abuse_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"moderate_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _moderateUserAdminAbuseReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abuse_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"moderate_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _moderateUserOrganizationAdminAbuseReportPath(gon.current_organization.path, ...args);
  }

  return _moderateUserAdminAbuseReportPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/abuse_reports(.:format)`
 * - Path helper: `admin_abuse_reports_path`
 * - URL helper: `admin_abuse_reports_url`
 * - controller#action: `admin/abuse_reports#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAbuseReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminAbuseReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abuse_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminAbuseReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abuse_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminAbuseReportsPath(gon.current_organization.path, ...args);
  }

  return _adminAbuseReportsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/abuse_reports/:id(.:format)`
 * - Path helper: `admin_abuse_report_path`
 * - URL helper: `admin_abuse_report_url`
 * - controller#action: `admin/abuse_reports#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAbuseReportPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminAbuseReportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abuse_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminAbuseReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abuse_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminAbuseReportPath(gon.current_organization.path, ...args);
  }

  return _adminAbuseReportPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/gitaly_servers(.:format)`
 * - Path helper: `admin_gitaly_servers_path`
 * - URL helper: `admin_gitaly_servers_url`
 * - controller#action: `admin/gitaly_servers#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGitalyServersPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminGitalyServersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gitaly_servers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminGitalyServersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gitaly_servers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminGitalyServersPath(gon.current_organization.path, ...args);
  }

  return _adminGitalyServersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/spam_logs/:id/mark_as_ham(.:format)`
 * - Path helper: `mark_as_ham_admin_spam_log_path`
 * - URL helper: `mark_as_ham_admin_spam_log_url`
 * - controller#action: `admin/spam_logs#mark_as_ham`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsHamAdminSpamLogPath = /*#__PURE__*/ (...args) => {
  const _markAsHamOrganizationAdminSpamLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"spam_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_ham"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _markAsHamAdminSpamLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"spam_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_ham"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _markAsHamOrganizationAdminSpamLogPath(gon.current_organization.path, ...args);
  }

  return _markAsHamAdminSpamLogPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/spam_logs(.:format)`
 * - Path helper: `admin_spam_logs_path`
 * - URL helper: `admin_spam_logs_url`
 * - controller#action: `admin/spam_logs#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSpamLogsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminSpamLogsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"spam_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminSpamLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"spam_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminSpamLogsPath(gon.current_organization.path, ...args);
  }

  return _adminSpamLogsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/spam_logs/:id(.:format)`
 * - Path helper: `admin_spam_log_path`
 * - URL helper: `admin_spam_log_url`
 * - controller#action: `admin/spam_logs#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSpamLogPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminSpamLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"spam_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminSpamLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"spam_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminSpamLogPath(gon.current_organization.path, ...args);
  }

  return _adminSpamLogPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/applications/:id/renew(.:format)`
 * - Path helper: `renew_admin_application_path`
 * - URL helper: `renew_admin_application_url`
 * - controller#action: `admin/applications#renew`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewAdminApplicationPath = /*#__PURE__*/ (...args) => {
  const _renewOrganizationAdminApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _renewAdminApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _renewOrganizationAdminApplicationPath(gon.current_organization.path, ...args);
  }

  return _renewAdminApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/applications(.:format)`
 * - Path helper: `admin_applications_path`
 * - URL helper: `admin_applications_url`
 * - controller#action: `admin/applications#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminApplicationsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminApplicationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminApplicationsPath(gon.current_organization.path, ...args);
  }

  return _adminApplicationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/applications/new(.:format)`
 * - Path helper: `new_admin_application_path`
 * - URL helper: `new_admin_application_url`
 * - controller#action: `admin/applications#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminApplicationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminApplicationPath(gon.current_organization.path, ...args);
  }

  return _newAdminApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/applications/:id/edit(.:format)`
 * - Path helper: `edit_admin_application_path`
 * - URL helper: `edit_admin_application_url`
 * - controller#action: `admin/applications#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminApplicationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editAdminApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminApplicationPath(gon.current_organization.path, ...args);
  }

  return _editAdminApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/applications/:id(.:format)`
 * - Path helper: `admin_application_path`
 * - URL helper: `admin_application_url`
 * - controller#action: `admin/applications#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminApplicationPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminApplicationPath(gon.current_organization.path, ...args);
  }

  return _adminApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/groups/active(.:format)`
 * - Path helper: `active_admin_groups_path`
 * - URL helper: `active_admin_groups_url`
 * - controller#action: `admin/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminGroupsPath = /*#__PURE__*/ (...args) => {
  const _activeOrganizationAdminGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _activeAdminGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _activeOrganizationAdminGroupsPath(gon.current_organization.path, ...args);
  }

  return _activeAdminGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/groups/inactive(.:format)`
 * - Path helper: `inactive_admin_groups_path`
 * - URL helper: `inactive_admin_groups_url`
 * - controller#action: `admin/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inactiveAdminGroupsPath = /*#__PURE__*/ (...args) => {
  const _inactiveOrganizationAdminGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _inactiveAdminGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _inactiveOrganizationAdminGroupsPath(gon.current_organization.path, ...args);
  }

  return _inactiveAdminGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/groups(.:format)`
 * - Path helper: `admin_groups_path`
 * - URL helper: `admin_groups_url`
 * - controller#action: `admin/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGroupsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminGroupsPath(gon.current_organization.path, ...args);
  }

  return _adminGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/groups/new(.:format)`
 * - Path helper: `new_admin_group_path`
 * - URL helper: `new_admin_group_url`
 * - controller#action: `admin/groups#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminGroupPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminGroupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminGroupPath(gon.current_organization.path, ...args);
  }

  return _newAdminGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/organizations(.:format)`
 * - Path helper: `admin_organizations_path`
 * - URL helper: `admin_organizations_url`
 * - controller#action: `admin/organizations#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminOrganizationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminOrganizationsPath(gon.current_organization.path, ...args);
  }

  return _adminOrganizationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/groups/*id/members_update(.:format)`
 * - Path helper: `admin_group_members_update_path`
 * - URL helper: `admin_group_members_update_url`
 * - controller#action: `admin/groups#members_update`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGroupMembersUpdatePath = /*#__PURE__*/ (...args) => {
  const _organizationAdminGroupMembersUpdatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"members_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _adminGroupMembersUpdatePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"members_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminGroupMembersUpdatePath(gon.current_organization.path, ...args);
  }

  return _adminGroupMembersUpdatePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/groups/*id/edit(.:format)`
 * - Path helper: `admin_group_edit_path`
 * - URL helper: `admin_group_edit_url`
 * - controller#action: `admin/groups#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGroupEditPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminGroupEditPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _adminGroupEditPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminGroupEditPath(gon.current_organization.path, ...args);
  }

  return _adminGroupEditPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/groups/*id(.:format)`
 * - Path helper: `admin_group_path`
 * - URL helper: `admin_group_url`
 * - controller#action: `admin/groups#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminGroupPath(gon.current_organization.path, ...args);
  }

  return _adminGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/topics/:topic_id/avatar(.:format)`
 * - Path helper: `admin_topic_avatar_path`
 * - URL helper: `admin_topic_avatar_url`
 * - controller#action: `admin/topics/avatars#destroy`
 *
 * @param {any} topicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTopicAvatarPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminTopicAvatarPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _adminTopicAvatarPath = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminTopicAvatarPath(gon.current_organization.path, ...args);
  }

  return _adminTopicAvatarPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/topics/preview_markdown(.:format)`
 * - Path helper: `preview_markdown_admin_topics_path`
 * - URL helper: `preview_markdown_admin_topics_url`
 * - controller#action: `admin/topics#preview_markdown`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewMarkdownAdminTopicsPath = /*#__PURE__*/ (...args) => {
  const _previewMarkdownOrganizationAdminTopicsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _previewMarkdownAdminTopicsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _previewMarkdownOrganizationAdminTopicsPath(gon.current_organization.path, ...args);
  }

  return _previewMarkdownAdminTopicsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/topics/merge(.:format)`
 * - Path helper: `merge_admin_topics_path`
 * - URL helper: `merge_admin_topics_url`
 * - controller#action: `admin/topics#merge`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeAdminTopicsPath = /*#__PURE__*/ (...args) => {
  const _mergeOrganizationAdminTopicsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _mergeAdminTopicsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _mergeOrganizationAdminTopicsPath(gon.current_organization.path, ...args);
  }

  return _mergeAdminTopicsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/topics(.:format)`
 * - Path helper: `admin_topics_path`
 * - URL helper: `admin_topics_url`
 * - controller#action: `admin/topics#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTopicsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminTopicsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminTopicsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminTopicsPath(gon.current_organization.path, ...args);
  }

  return _adminTopicsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/topics/new(.:format)`
 * - Path helper: `new_admin_topic_path`
 * - URL helper: `new_admin_topic_url`
 * - controller#action: `admin/topics#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminTopicPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminTopicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminTopicPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminTopicPath(gon.current_organization.path, ...args);
  }

  return _newAdminTopicPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/topics/:id/edit(.:format)`
 * - Path helper: `edit_admin_topic_path`
 * - URL helper: `edit_admin_topic_url`
 * - controller#action: `admin/topics#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminTopicPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminTopicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editAdminTopicPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminTopicPath(gon.current_organization.path, ...args);
  }

  return _editAdminTopicPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/topics/:id(.:format)`
 * - Path helper: `admin_topic_path`
 * - URL helper: `admin_topic_url`
 * - controller#action: `admin/topics#update`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTopicPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminTopicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminTopicPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminTopicPath(gon.current_organization.path, ...args);
  }

  return _adminTopicPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/deploy_keys(.:format)`
 * - Path helper: `admin_deploy_keys_path`
 * - URL helper: `admin_deploy_keys_url`
 * - controller#action: `admin/deploy_keys#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDeployKeysPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminDeployKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deploy_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminDeployKeysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deploy_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminDeployKeysPath(gon.current_organization.path, ...args);
  }

  return _adminDeployKeysPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/deploy_keys/new(.:format)`
 * - Path helper: `new_admin_deploy_key_path`
 * - URL helper: `new_admin_deploy_key_url`
 * - controller#action: `admin/deploy_keys#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminDeployKeyPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminDeployKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminDeployKeyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminDeployKeyPath(gon.current_organization.path, ...args);
  }

  return _newAdminDeployKeyPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/deploy_keys/:id/edit(.:format)`
 * - Path helper: `edit_admin_deploy_key_path`
 * - URL helper: `edit_admin_deploy_key_url`
 * - controller#action: `admin/deploy_keys#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminDeployKeyPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminDeployKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editAdminDeployKeyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminDeployKeyPath(gon.current_organization.path, ...args);
  }

  return _editAdminDeployKeyPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/deploy_keys/:id(.:format)`
 * - Path helper: `admin_deploy_key_path`
 * - URL helper: `admin_deploy_key_url`
 * - controller#action: `admin/deploy_keys#update`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDeployKeyPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminDeployKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminDeployKeyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminDeployKeyPath(gon.current_organization.path, ...args);
  }

  return _adminDeployKeyPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/hooks/:id/test(.:format)`
 * - Path helper: `test_admin_hook_path`
 * - URL helper: `test_admin_hook_url`
 * - controller#action: `admin/hooks#test`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testAdminHookPath = /*#__PURE__*/ (...args) => {
  const _testOrganizationAdminHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _testAdminHookPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _testOrganizationAdminHookPath(gon.current_organization.path, ...args);
  }

  return _testAdminHookPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/hooks/:hook_id/hook_logs/:id/retry(.:format)`
 * - Path helper: `retry_admin_hook_hook_log_path`
 * - URL helper: `retry_admin_hook_hook_log_url`
 * - controller#action: `admin/hook_logs#retry`
 *
 * @param {any} hookId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryAdminHookHookLogPath = /*#__PURE__*/ (...args) => {
  const _retryOrganizationAdminHookHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _retryAdminHookHookLogPath = /*#__PURE__*/ __jsr.r({"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _retryOrganizationAdminHookHookLogPath(gon.current_organization.path, ...args);
  }

  return _retryAdminHookHookLogPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/hooks/:hook_id/hook_logs/:id(.:format)`
 * - Path helper: `admin_hook_hook_log_path`
 * - URL helper: `admin_hook_hook_log_url`
 * - controller#action: `admin/hook_logs#show`
 *
 * @param {any} hookId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminHookHookLogPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminHookHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _adminHookHookLogPath = /*#__PURE__*/ __jsr.r({"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminHookHookLogPath(gon.current_organization.path, ...args);
  }

  return _adminHookHookLogPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/hooks(.:format)`
 * - Path helper: `admin_hooks_path`
 * - URL helper: `admin_hooks_url`
 * - controller#action: `admin/hooks#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminHooksPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminHooksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminHooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminHooksPath(gon.current_organization.path, ...args);
  }

  return _adminHooksPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/hooks/:id/edit(.:format)`
 * - Path helper: `edit_admin_hook_path`
 * - URL helper: `edit_admin_hook_url`
 * - controller#action: `admin/hooks#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminHookPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editAdminHookPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminHookPath(gon.current_organization.path, ...args);
  }

  return _editAdminHookPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/hooks/:id(.:format)`
 * - Path helper: `admin_hook_path`
 * - URL helper: `admin_hook_url`
 * - controller#action: `admin/hooks#update`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminHookPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminHookPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminHookPath(gon.current_organization.path, ...args);
  }

  return _adminHookPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/broadcast_messages/preview(.:format)`
 * - Path helper: `preview_admin_broadcast_messages_path`
 * - URL helper: `preview_admin_broadcast_messages_url`
 * - controller#action: `admin/broadcast_messages#preview`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewAdminBroadcastMessagesPath = /*#__PURE__*/ (...args) => {
  const _previewOrganizationAdminBroadcastMessagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"broadcast_messages"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _previewAdminBroadcastMessagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"broadcast_messages"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _previewOrganizationAdminBroadcastMessagesPath(gon.current_organization.path, ...args);
  }

  return _previewAdminBroadcastMessagesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/broadcast_messages(.:format)`
 * - Path helper: `admin_broadcast_messages_path`
 * - URL helper: `admin_broadcast_messages_url`
 * - controller#action: `admin/broadcast_messages#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBroadcastMessagesPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminBroadcastMessagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"broadcast_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminBroadcastMessagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"broadcast_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminBroadcastMessagesPath(gon.current_organization.path, ...args);
  }

  return _adminBroadcastMessagesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/broadcast_messages/:id/edit(.:format)`
 * - Path helper: `edit_admin_broadcast_message_path`
 * - URL helper: `edit_admin_broadcast_message_url`
 * - controller#action: `admin/broadcast_messages#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminBroadcastMessagePath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminBroadcastMessagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"broadcast_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editAdminBroadcastMessagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"broadcast_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminBroadcastMessagePath(gon.current_organization.path, ...args);
  }

  return _editAdminBroadcastMessagePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/broadcast_messages/:id(.:format)`
 * - Path helper: `admin_broadcast_message_path`
 * - URL helper: `admin_broadcast_message_url`
 * - controller#action: `admin/broadcast_messages#update`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBroadcastMessagePath = /*#__PURE__*/ (...args) => {
  const _organizationAdminBroadcastMessagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"broadcast_messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminBroadcastMessagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"broadcast_messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminBroadcastMessagePath(gon.current_organization.path, ...args);
  }

  return _adminBroadcastMessagePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/instance_review(.:format)`
 * - Path helper: `admin_instance_review_path`
 * - URL helper: `admin_instance_review_url`
 * - controller#action: `admin/instance_review#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstanceReviewPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminInstanceReviewPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instance_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminInstanceReviewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instance_review"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminInstanceReviewPath(gon.current_organization.path, ...args);
  }

  return _adminInstanceReviewPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/background_migrations/:background_migration_id/batched_jobs/:id(.:format)`
 * - Path helper: `admin_background_migration_batched_job_path`
 * - URL helper: `admin_background_migration_batched_job_url`
 * - controller#action: `admin/batched_jobs#show`
 *
 * @param {any} backgroundMigrationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBackgroundMigrationBatchedJobPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminBackgroundMigrationBatchedJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"background_migration_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"background_migration_id"],[2,[7,"/"],[2,[6,"batched_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _adminBackgroundMigrationBatchedJobPath = /*#__PURE__*/ __jsr.r({"background_migration_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"background_migration_id"],[2,[7,"/"],[2,[6,"batched_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminBackgroundMigrationBatchedJobPath(gon.current_organization.path, ...args);
  }

  return _adminBackgroundMigrationBatchedJobPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/background_migrations/:id/pause(.:format)`
 * - Path helper: `pause_admin_background_migration_path`
 * - URL helper: `pause_admin_background_migration_url`
 * - controller#action: `admin/background_migrations#pause`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseAdminBackgroundMigrationPath = /*#__PURE__*/ (...args) => {
  const _pauseOrganizationAdminBackgroundMigrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _pauseAdminBackgroundMigrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _pauseOrganizationAdminBackgroundMigrationPath(gon.current_organization.path, ...args);
  }

  return _pauseAdminBackgroundMigrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/background_migrations/:id/resume(.:format)`
 * - Path helper: `resume_admin_background_migration_path`
 * - URL helper: `resume_admin_background_migration_url`
 * - controller#action: `admin/background_migrations#resume`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeAdminBackgroundMigrationPath = /*#__PURE__*/ (...args) => {
  const _resumeOrganizationAdminBackgroundMigrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _resumeAdminBackgroundMigrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resumeOrganizationAdminBackgroundMigrationPath(gon.current_organization.path, ...args);
  }

  return _resumeAdminBackgroundMigrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/background_migrations/:id/retry(.:format)`
 * - Path helper: `retry_admin_background_migration_path`
 * - URL helper: `retry_admin_background_migration_url`
 * - controller#action: `admin/background_migrations#retry`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryAdminBackgroundMigrationPath = /*#__PURE__*/ (...args) => {
  const _retryOrganizationAdminBackgroundMigrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _retryAdminBackgroundMigrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _retryOrganizationAdminBackgroundMigrationPath(gon.current_organization.path, ...args);
  }

  return _retryAdminBackgroundMigrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/background_migrations(.:format)`
 * - Path helper: `admin_background_migrations_path`
 * - URL helper: `admin_background_migrations_url`
 * - controller#action: `admin/background_migrations#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBackgroundMigrationsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminBackgroundMigrationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminBackgroundMigrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminBackgroundMigrationsPath(gon.current_organization.path, ...args);
  }

  return _adminBackgroundMigrationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/background_migrations/:id(.:format)`
 * - Path helper: `admin_background_migration_path`
 * - URL helper: `admin_background_migration_url`
 * - controller#action: `admin/background_migrations#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBackgroundMigrationPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminBackgroundMigrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminBackgroundMigrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_migrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminBackgroundMigrationPath(gon.current_organization.path, ...args);
  }

  return _adminBackgroundMigrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/health_check(.:format)`
 * - Path helper: `admin_health_check_path`
 * - URL helper: `admin_health_check_url`
 * - controller#action: `admin/health_check#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminHealthCheckPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminHealthCheckPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"health_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"health_check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminHealthCheckPath(gon.current_organization.path, ...args);
  }

  return _adminHealthCheckPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/background_jobs(.:format)`
 * - Path helper: `admin_background_jobs_path`
 * - URL helper: `admin_background_jobs_url`
 * - controller#action: `admin/background_jobs#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBackgroundJobsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminBackgroundJobsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminBackgroundJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminBackgroundJobsPath(gon.current_organization.path, ...args);
  }

  return _adminBackgroundJobsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/database_diagnostics/run_collation_check(.:format)`
 * - Path helper: `run_collation_check_admin_database_diagnostics_path`
 * - URL helper: `run_collation_check_admin_database_diagnostics_url`
 * - controller#action: `admin/database_diagnostics#run_collation_check`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runCollationCheckAdminDatabaseDiagnosticsPath = /*#__PURE__*/ (...args) => {
  const _runCollationCheckOrganizationAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[2,[7,"/"],[2,[6,"run_collation_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _runCollationCheckAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[2,[7,"/"],[2,[6,"run_collation_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _runCollationCheckOrganizationAdminDatabaseDiagnosticsPath(gon.current_organization.path, ...args);
  }

  return _runCollationCheckAdminDatabaseDiagnosticsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/database_diagnostics/collation_check_results(.:format)`
 * - Path helper: `collation_check_results_admin_database_diagnostics_path`
 * - URL helper: `collation_check_results_admin_database_diagnostics_url`
 * - controller#action: `admin/database_diagnostics#collation_check_results`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collationCheckResultsAdminDatabaseDiagnosticsPath = /*#__PURE__*/ (...args) => {
  const _collationCheckResultsOrganizationAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[2,[7,"/"],[2,[6,"collation_check_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _collationCheckResultsAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[2,[7,"/"],[2,[6,"collation_check_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _collationCheckResultsOrganizationAdminDatabaseDiagnosticsPath(gon.current_organization.path, ...args);
  }

  return _collationCheckResultsAdminDatabaseDiagnosticsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/database_diagnostics/run_schema_check(.:format)`
 * - Path helper: `run_schema_check_admin_database_diagnostics_path`
 * - URL helper: `run_schema_check_admin_database_diagnostics_url`
 * - controller#action: `admin/database_diagnostics#run_schema_check`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runSchemaCheckAdminDatabaseDiagnosticsPath = /*#__PURE__*/ (...args) => {
  const _runSchemaCheckOrganizationAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[2,[7,"/"],[2,[6,"run_schema_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _runSchemaCheckAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[2,[7,"/"],[2,[6,"run_schema_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _runSchemaCheckOrganizationAdminDatabaseDiagnosticsPath(gon.current_organization.path, ...args);
  }

  return _runSchemaCheckAdminDatabaseDiagnosticsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/database_diagnostics/schema_check_results(.:format)`
 * - Path helper: `schema_check_results_admin_database_diagnostics_path`
 * - URL helper: `schema_check_results_admin_database_diagnostics_url`
 * - controller#action: `admin/database_diagnostics#schema_check_results`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schemaCheckResultsAdminDatabaseDiagnosticsPath = /*#__PURE__*/ (...args) => {
  const _schemaCheckResultsOrganizationAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[2,[7,"/"],[2,[6,"schema_check_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _schemaCheckResultsAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[2,[7,"/"],[2,[6,"schema_check_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _schemaCheckResultsOrganizationAdminDatabaseDiagnosticsPath(gon.current_organization.path, ...args);
  }

  return _schemaCheckResultsAdminDatabaseDiagnosticsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/database_diagnostics(.:format)`
 * - Path helper: `admin_database_diagnostics_path`
 * - URL helper: `admin_database_diagnostics_url`
 * - controller#action: `admin/database_diagnostics#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDatabaseDiagnosticsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminDatabaseDiagnosticsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"database_diagnostics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminDatabaseDiagnosticsPath(gon.current_organization.path, ...args);
  }

  return _adminDatabaseDiagnosticsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/system_info(.:format)`
 * - Path helper: `admin_system_info_path`
 * - URL helper: `admin_system_info_url`
 * - controller#action: `admin/system_info#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSystemInfoPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminSystemInfoPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminSystemInfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminSystemInfoPath(gon.current_organization.path, ...args);
  }

  return _adminSystemInfoPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects/active(.:format)`
 * - Path helper: `active_admin_projects_path`
 * - URL helper: `active_admin_projects_url`
 * - controller#action: `admin/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminProjectsPath = /*#__PURE__*/ (...args) => {
  const _activeOrganizationAdminProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _activeAdminProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _activeOrganizationAdminProjectsPath(gon.current_organization.path, ...args);
  }

  return _activeAdminProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects/inactive(.:format)`
 * - Path helper: `inactive_admin_projects_path`
 * - URL helper: `inactive_admin_projects_url`
 * - controller#action: `admin/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inactiveAdminProjectsPath = /*#__PURE__*/ (...args) => {
  const _inactiveOrganizationAdminProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _inactiveAdminProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _inactiveOrganizationAdminProjectsPath(gon.current_organization.path, ...args);
  }

  return _inactiveAdminProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects(.:format)`
 * - Path helper: `admin_projects_path`
 * - URL helper: `admin_projects_url`
 * - controller#action: `admin/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminProjectsPath(gon.current_organization.path, ...args);
  }

  return _adminProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/usage_trends(.:format)`
 * - Path helper: `admin_usage_trends_path`
 * - URL helper: `admin_usage_trends_url`
 * - controller#action: `admin/usage_trends#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUsageTrendsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminUsageTrendsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"usage_trends"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminUsageTrendsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"usage_trends"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminUsageTrendsPath(gon.current_organization.path, ...args);
  }

  return _adminUsageTrendsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/dev_ops_reports(.:format)`
 * - Path helper: `admin_dev_ops_reports_path`
 * - URL helper: `admin_dev_ops_reports_url`
 * - controller#action: `admin/dev_ops_report#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDevOpsReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminDevOpsReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dev_ops_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminDevOpsReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dev_ops_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminDevOpsReportsPath(gon.current_organization.path, ...args);
  }

  return _adminDevOpsReportsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/dev_ops_report(.:format)`
 * - Path helper: `admin_dev_ops_report_path`
 * - URL helper: `admin_dev_ops_report_url`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDevOpsReportPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminDevOpsReportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dev_ops_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminDevOpsReportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dev_ops_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminDevOpsReportPath(gon.current_organization.path, ...args);
  }

  return _adminDevOpsReportPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/cohorts(.:format)`
 * - Path helper: `admin_cohorts_path`
 * - URL helper: `admin_cohorts_url`
 * - controller#action: `admin/cohorts#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCohortsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminCohortsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cohorts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminCohortsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cohorts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminCohortsPath(gon.current_organization.path, ...args);
  }

  return _adminCohortsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects/:project_full_path/transfer(.:format)`
 * - Path helper: `transfer_admin_project_path`
 * - URL helper: `transfer_admin_project_url`
 * - controller#action: `admin/projects#transfer`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transferAdminProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _transferOrganizationAdminNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _transferAdminNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _transferOrganizationAdminNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _transferAdminNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects/:project_full_path/repository_check(.:format)`
 * - Path helper: `repository_check_admin_project_path`
 * - URL helper: `repository_check_admin_project_url`
 * - controller#action: `admin/projects#repository_check`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repositoryCheckAdminProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _repositoryCheckOrganizationAdminNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"repository_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _repositoryCheckAdminNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"repository_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _repositoryCheckOrganizationAdminNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _repositoryCheckAdminNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects/:project_full_path/edit(.:format)`
 * - Path helper: `edit_admin_project_path`
 * - URL helper: `edit_admin_project_url`
 * - controller#action: `admin/projects#edit`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationAdminNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _editAdminNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editAdminNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects/:project_full_path(.:format)`
 * - Path helper: `admin_project_path`
 * - URL helper: `admin_project_url`
 * - controller#action: `admin/projects#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationAdminNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _adminNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _adminNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects/:project_full_path/runner_projects(.:format)`
 * - Path helper: `admin_project_runner_projects_path`
 * - URL helper: `admin_project_runner_projects_url`
 * - controller#action: `admin/runner_projects#create`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProjectRunnerProjectsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationAdminNamespaceProjectRunnerProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"runner_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _adminNamespaceProjectRunnerProjectsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"runner_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminNamespaceProjectRunnerProjectsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _adminNamespaceProjectRunnerProjectsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/projects/:project_full_path/runner_projects/:id(.:format)`
 * - Path helper: `admin_project_runner_project_path`
 * - URL helper: `admin_project_runner_project_url`
 * - controller#action: `admin/runner_projects#destroy`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProjectRunnerProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationAdminNamespaceProjectRunnerProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"runner_projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _adminNamespaceProjectRunnerProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"runner_projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminNamespaceProjectRunnerProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _adminNamespaceProjectRunnerProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/integrations/:id/overrides(.:format)`
 * - Path helper: `overrides_admin_application_settings_integration_path`
 * - URL helper: `overrides_admin_application_settings_integration_url`
 * - controller#action: `admin/integrations#overrides`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overridesAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _overridesOrganizationAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _overridesAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _overridesOrganizationAdminApplicationSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _overridesAdminApplicationSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/integrations/:id/test(.:format)`
 * - Path helper: `test_admin_application_settings_integration_path`
 * - URL helper: `test_admin_application_settings_integration_url`
 * - controller#action: `admin/integrations#test`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _testOrganizationAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _testAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _testOrganizationAdminApplicationSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _testAdminApplicationSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/integrations/:id/reset(.:format)`
 * - Path helper: `reset_admin_application_settings_integration_path`
 * - URL helper: `reset_admin_application_settings_integration_url`
 * - controller#action: `admin/integrations#reset`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _resetOrganizationAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _resetAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetOrganizationAdminApplicationSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _resetAdminApplicationSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/integrations/:id/edit(.:format)`
 * - Path helper: `edit_admin_application_settings_integration_path`
 * - URL helper: `edit_admin_application_settings_integration_url`
 * - controller#action: `admin/integrations#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _editAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminApplicationSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _editAdminApplicationSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/integrations/:id(.:format)`
 * - Path helper: `admin_application_settings_integration_path`
 * - URL helper: `admin_application_settings_integration_url`
 * - controller#action: `admin/integrations#update`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminApplicationSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _adminApplicationSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminApplicationSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _adminApplicationSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/slack/slack_auth(.:format)`
 * - Path helper: `slack_auth_admin_application_settings_slack_path`
 * - URL helper: `slack_auth_admin_application_settings_slack_url`
 * - controller#action: `admin/slacks#slack_auth`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slackAuthAdminApplicationSettingsSlackPath = /*#__PURE__*/ (...args) => {
  const _slackAuthOrganizationAdminApplicationSettingsSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"slack_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _slackAuthAdminApplicationSettingsSlackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"slack_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _slackAuthOrganizationAdminApplicationSettingsSlackPath(gon.current_organization.path, ...args);
  }

  return _slackAuthAdminApplicationSettingsSlackPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/slack(.:format)`
 * - Path helper: `admin_application_settings_slack_path`
 * - URL helper: `admin_application_settings_slack_url`
 * - controller#action: `admin/slacks#destroy`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminApplicationSettingsSlackPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminApplicationSettingsSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminApplicationSettingsSlackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminApplicationSettingsSlackPath(gon.current_organization.path, ...args);
  }

  return _adminApplicationSettingsSlackPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/usage_data(.:format)`
 * - Path helper: `usage_data_admin_application_settings_path`
 * - URL helper: `usage_data_admin_application_settings_url`
 * - controller#action: `admin/application_settings#usage_data`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usageDataAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _usageDataOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"usage_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _usageDataAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"usage_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _usageDataOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _usageDataAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/reset_registration_token(.:format)`
 * - Path helper: `reset_registration_token_admin_application_settings_path`
 * - URL helper: `reset_registration_token_admin_application_settings_url`
 * - controller#action: `admin/application_settings#reset_registration_token`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetRegistrationTokenAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _resetRegistrationTokenOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reset_registration_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _resetRegistrationTokenAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reset_registration_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetRegistrationTokenOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _resetRegistrationTokenAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/reset_health_check_token(.:format)`
 * - Path helper: `reset_health_check_token_admin_application_settings_path`
 * - URL helper: `reset_health_check_token_admin_application_settings_url`
 * - controller#action: `admin/application_settings#reset_health_check_token`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetHealthCheckTokenAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _resetHealthCheckTokenOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reset_health_check_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _resetHealthCheckTokenAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reset_health_check_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetHealthCheckTokenOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _resetHealthCheckTokenAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/reset_error_tracking_access_token(.:format)`
 * - Path helper: `reset_error_tracking_access_token_admin_application_settings_path`
 * - URL helper: `reset_error_tracking_access_token_admin_application_settings_url`
 * - controller#action: `admin/application_settings#reset_error_tracking_access_token`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetErrorTrackingAccessTokenAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _resetErrorTrackingAccessTokenOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reset_error_tracking_access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _resetErrorTrackingAccessTokenAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reset_error_tracking_access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetErrorTrackingAccessTokenOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _resetErrorTrackingAccessTokenAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/clear_repository_check_states(.:format)`
 * - Path helper: `clear_repository_check_states_admin_application_settings_path`
 * - URL helper: `clear_repository_check_states_admin_application_settings_url`
 * - controller#action: `admin/application_settings#clear_repository_check_states`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearRepositoryCheckStatesAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _clearRepositoryCheckStatesOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"clear_repository_check_states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _clearRepositoryCheckStatesAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"clear_repository_check_states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _clearRepositoryCheckStatesOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _clearRepositoryCheckStatesAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/reset_vscode_extension_marketplace_extension_host_domain(.:format)`
 * - Path helper: `reset_vscode_extension_marketplace_extension_host_domain_admin_application_settings_path`
 * - URL helper: `reset_vscode_extension_marketplace_extension_host_domain_admin_application_settings_url`
 * - controller#action: `admin/application_settings#reset_vscode_extension_marketplace_extension_host_domain`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetVSCodeExtensionMarketplaceExtensionHostDomainAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _resetVSCodeExtensionMarketplaceExtensionHostDomainOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reset_vscode_extension_marketplace_extension_host_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _resetVSCodeExtensionMarketplaceExtensionHostDomainAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reset_vscode_extension_marketplace_extension_host_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetVSCodeExtensionMarketplaceExtensionHostDomainOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _resetVSCodeExtensionMarketplaceExtensionHostDomainAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/general(.:format)`
 * - Path helper: `general_admin_application_settings_path`
 * - URL helper: `general_admin_application_settings_url`
 * - controller#action: `admin/application_settings#general`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generalAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _generalOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"general"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _generalAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"general"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _generalOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _generalAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/integrations(.:format)`
 * - Path helper: `integrations_admin_application_settings_path`
 * - URL helper: `integrations_admin_application_settings_url`
 * - controller#action: `admin/application_settings#integrations`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrationsAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _integrationsOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _integrationsAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _integrationsOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _integrationsAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/repository(.:format)`
 * - Path helper: `repository_admin_application_settings_path`
 * - URL helper: `repository_admin_application_settings_url`
 * - controller#action: `admin/application_settings#repository`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repositoryAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _repositoryOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"repository"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _repositoryAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"repository"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _repositoryOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _repositoryAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/ci_cd(.:format)`
 * - Path helper: `ci_cd_admin_application_settings_path`
 * - URL helper: `ci_cd_admin_application_settings_url`
 * - controller#action: `admin/application_settings#ci_cd`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ciCdAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _ciCdOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _ciCdAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _ciCdOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _ciCdAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/reporting(.:format)`
 * - Path helper: `reporting_admin_application_settings_path`
 * - URL helper: `reporting_admin_application_settings_url`
 * - controller#action: `admin/application_settings#reporting`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportingAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _reportingOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _reportingAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _reportingOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _reportingAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/metrics_and_profiling(.:format)`
 * - Path helper: `metrics_and_profiling_admin_application_settings_path`
 * - URL helper: `metrics_and_profiling_admin_application_settings_url`
 * - controller#action: `admin/application_settings#metrics_and_profiling`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metricsAndProfilingAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _metricsAndProfilingOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"metrics_and_profiling"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _metricsAndProfilingAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"metrics_and_profiling"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _metricsAndProfilingOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _metricsAndProfilingAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/network(.:format)`
 * - Path helper: `network_admin_application_settings_path`
 * - URL helper: `network_admin_application_settings_url`
 * - controller#action: `admin/application_settings#network`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const networkAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _networkOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"network"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _networkAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"network"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _networkOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _networkAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/preferences(.:format)`
 * - Path helper: `preferences_admin_application_settings_path`
 * - URL helper: `preferences_admin_application_settings_url`
 * - controller#action: `admin/application_settings#preferences`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preferencesAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _preferencesOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _preferencesAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _preferencesOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _preferencesAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/usage_quotas(.:format)`
 * - Path helper: `usage_quotas_admin_application_settings_path`
 * - URL helper: `usage_quotas_admin_application_settings_url`
 * - controller#action: `admin/application_settings#usage_quotas`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usageQuotasAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _usageQuotasOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"usage_quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _usageQuotasAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"usage_quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _usageQuotasOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _usageQuotasAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/lets_encrypt_terms_of_service(.:format)`
 * - Path helper: `lets_encrypt_terms_of_service_admin_application_settings_path`
 * - URL helper: `lets_encrypt_terms_of_service_admin_application_settings_url`
 * - controller#action: `admin/application_settings#lets_encrypt_terms_of_service`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letsEncryptTermsOfServiceAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _letsEncryptTermsOfServiceOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"lets_encrypt_terms_of_service"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _letsEncryptTermsOfServiceAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"lets_encrypt_terms_of_service"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _letsEncryptTermsOfServiceOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _letsEncryptTermsOfServiceAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/slack_app_manifest_download(.:format)`
 * - Path helper: `slack_app_manifest_download_admin_application_settings_path`
 * - URL helper: `slack_app_manifest_download_admin_application_settings_url`
 * - controller#action: `admin/application_settings#slack_app_manifest_download`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slackAppManifestDownloadAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _slackAppManifestDownloadOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"slack_app_manifest_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _slackAppManifestDownloadAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"slack_app_manifest_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _slackAppManifestDownloadOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _slackAppManifestDownloadAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/slack_app_manifest_share(.:format)`
 * - Path helper: `slack_app_manifest_share_admin_application_settings_path`
 * - URL helper: `slack_app_manifest_share_admin_application_settings_url`
 * - controller#action: `admin/application_settings#slack_app_manifest_share`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slackAppManifestShareAdminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _slackAppManifestShareOrganizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"slack_app_manifest_share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _slackAppManifestShareAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"slack_app_manifest_share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _slackAppManifestShareOrganizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _slackAppManifestShareAdminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/service_accounts(/*vueroute)(.:format)`
 * - Path helper: `admin_application_settings_service_accounts_path`
 * - URL helper: `admin_application_settings_service_accounts_url`
 * - controller#action: `admin/application_settings/service_accounts#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminApplicationSettingsServiceAccountsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminApplicationSettingsServiceAccountsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"service_accounts"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);
  const _adminApplicationSettingsServiceAccountsPath = /*#__PURE__*/ __jsr.r({"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"service_accounts"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminApplicationSettingsServiceAccountsPath(gon.current_organization.path, ...args);
  }

  return _adminApplicationSettingsServiceAccountsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/appearance/preview_sign_in(.:format)`
 * - Path helper: `preview_sign_in_admin_application_settings_appearances_path`
 * - URL helper: `preview_sign_in_admin_application_settings_appearances_url`
 * - controller#action: `admin/application_settings/appearances#preview_sign_in`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewSignInAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ (...args) => {
  const _previewSignInOrganizationAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"preview_sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _previewSignInAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"preview_sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _previewSignInOrganizationAdminApplicationSettingsAppearancesPath(gon.current_organization.path, ...args);
  }

  return _previewSignInAdminApplicationSettingsAppearancesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/appearance/logo(.:format)`
 * - Path helper: `logo_admin_application_settings_appearances_path`
 * - URL helper: `logo_admin_application_settings_appearances_url`
 * - controller#action: `admin/application_settings/appearances#logo`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logoAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ (...args) => {
  const _logoOrganizationAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _logoAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _logoOrganizationAdminApplicationSettingsAppearancesPath(gon.current_organization.path, ...args);
  }

  return _logoAdminApplicationSettingsAppearancesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/appearance/pwa_icon(.:format)`
 * - Path helper: `pwa_icon_admin_application_settings_appearances_path`
 * - URL helper: `pwa_icon_admin_application_settings_appearances_url`
 * - controller#action: `admin/application_settings/appearances#pwa_icon`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwaIconAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ (...args) => {
  const _pwaIconOrganizationAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"pwa_icon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _pwaIconAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"pwa_icon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _pwaIconOrganizationAdminApplicationSettingsAppearancesPath(gon.current_organization.path, ...args);
  }

  return _pwaIconAdminApplicationSettingsAppearancesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/appearance/header_logos(.:format)`
 * - Path helper: `header_logos_admin_application_settings_appearances_path`
 * - URL helper: `header_logos_admin_application_settings_appearances_url`
 * - controller#action: `admin/application_settings/appearances#header_logos`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const headerLogosAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ (...args) => {
  const _headerLogosOrganizationAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"header_logos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _headerLogosAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"header_logos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _headerLogosOrganizationAdminApplicationSettingsAppearancesPath(gon.current_organization.path, ...args);
  }

  return _headerLogosAdminApplicationSettingsAppearancesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/appearance/favicon(.:format)`
 * - Path helper: `favicon_admin_application_settings_appearances_path`
 * - URL helper: `favicon_admin_application_settings_appearances_url`
 * - controller#action: `admin/application_settings/appearances#favicon`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faviconAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ (...args) => {
  const _faviconOrganizationAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"favicon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _faviconAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[6,"favicon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _faviconOrganizationAdminApplicationSettingsAppearancesPath(gon.current_organization.path, ...args);
  }

  return _faviconAdminApplicationSettingsAppearancesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings/appearance(.:format)`
 * - Path helper: `admin_application_settings_appearances_path`
 * - URL helper: `admin_application_settings_appearances_url`
 * - controller#action: `admin/application_settings/appearances#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminApplicationSettingsAppearancesPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminApplicationSettingsAppearancesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[2,[7,"/"],[2,[6,"appearance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminApplicationSettingsAppearancesPath(gon.current_organization.path, ...args);
  }

  return _adminApplicationSettingsAppearancesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/application_settings(.:format)`
 * - Path helper: `admin_application_settings_path`
 * - URL helper: `admin_application_settings_url`
 * - controller#action: `admin/application_settings#update`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _adminApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/plan_limits(.:format)`
 * - Path helper: `admin_plan_limits_path`
 * - URL helper: `admin_plan_limits_url`
 * - controller#action: `admin/plan_limits#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPlanLimitsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminPlanLimitsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"plan_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminPlanLimitsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"plan_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminPlanLimitsPath(gon.current_organization.path, ...args);
  }

  return _adminPlanLimitsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/packages_limits(.:format)`
 * - Path helper: `admin_packages_limits_path`
 * - URL helper: `admin_packages_limits_url`
 * - controller#action: `admin/packages_limits#update`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPackagesLimitsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminPackagesLimitsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminPackagesLimitsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminPackagesLimitsPath(gon.current_organization.path, ...args);
  }

  return _adminPackagesLimitsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/labels(.:format)`
 * - Path helper: `admin_labels_path`
 * - URL helper: `admin_labels_url`
 * - controller#action: `admin/labels#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLabelsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminLabelsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminLabelsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminLabelsPath(gon.current_organization.path, ...args);
  }

  return _adminLabelsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/labels/new(.:format)`
 * - Path helper: `new_admin_label_path`
 * - URL helper: `new_admin_label_url`
 * - controller#action: `admin/labels#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminLabelPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminLabelPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminLabelPath(gon.current_organization.path, ...args);
  }

  return _newAdminLabelPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/labels/:id/edit(.:format)`
 * - Path helper: `edit_admin_label_path`
 * - URL helper: `edit_admin_label_url`
 * - controller#action: `admin/labels#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminLabelPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editAdminLabelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminLabelPath(gon.current_organization.path, ...args);
  }

  return _editAdminLabelPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/labels/:id(.:format)`
 * - Path helper: `admin_label_path`
 * - URL helper: `admin_label_url`
 * - controller#action: `admin/labels#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLabelPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminLabelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminLabelPath(gon.current_organization.path, ...args);
  }

  return _adminLabelPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners/:id/register(.:format)`
 * - Path helper: `register_admin_runner_path`
 * - URL helper: `register_admin_runner_url`
 * - controller#action: `admin/runners#register`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registerAdminRunnerPath = /*#__PURE__*/ (...args) => {
  const _registerOrganizationAdminRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _registerAdminRunnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _registerOrganizationAdminRunnerPath(gon.current_organization.path, ...args);
  }

  return _registerAdminRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners/:id/resume(.:format)`
 * - Path helper: `resume_admin_runner_path`
 * - URL helper: `resume_admin_runner_url`
 * - controller#action: `admin/runners#resume`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeAdminRunnerPath = /*#__PURE__*/ (...args) => {
  const _resumeOrganizationAdminRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _resumeAdminRunnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resumeOrganizationAdminRunnerPath(gon.current_organization.path, ...args);
  }

  return _resumeAdminRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners/:id/pause(.:format)`
 * - Path helper: `pause_admin_runner_path`
 * - URL helper: `pause_admin_runner_url`
 * - controller#action: `admin/runners#pause`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseAdminRunnerPath = /*#__PURE__*/ (...args) => {
  const _pauseOrganizationAdminRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _pauseAdminRunnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _pauseOrganizationAdminRunnerPath(gon.current_organization.path, ...args);
  }

  return _pauseAdminRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners/tag_list(.:format)`
 * - Path helper: `tag_list_admin_runners_path`
 * - URL helper: `tag_list_admin_runners_url`
 * - controller#action: `admin/runners#tag_list`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tagListAdminRunnersPath = /*#__PURE__*/ (...args) => {
  const _tagListOrganizationAdminRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"tag_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _tagListAdminRunnersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"tag_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _tagListOrganizationAdminRunnersPath(gon.current_organization.path, ...args);
  }

  return _tagListAdminRunnersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners/runner_setup_scripts(.:format)`
 * - Path helper: `runner_setup_scripts_admin_runners_path`
 * - URL helper: `runner_setup_scripts_admin_runners_url`
 * - controller#action: `admin/runners#runner_setup_scripts`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runnerSetupScriptsAdminRunnersPath = /*#__PURE__*/ (...args) => {
  const _runnerSetupScriptsOrganizationAdminRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"runner_setup_scripts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _runnerSetupScriptsAdminRunnersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"runner_setup_scripts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _runnerSetupScriptsOrganizationAdminRunnersPath(gon.current_organization.path, ...args);
  }

  return _runnerSetupScriptsAdminRunnersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners(.:format)`
 * - Path helper: `admin_runners_path`
 * - URL helper: `admin_runners_url`
 * - controller#action: `admin/runners#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRunnersPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminRunnersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminRunnersPath(gon.current_organization.path, ...args);
  }

  return _adminRunnersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners/new(.:format)`
 * - Path helper: `new_admin_runner_path`
 * - URL helper: `new_admin_runner_url`
 * - controller#action: `admin/runners#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminRunnerPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationAdminRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newAdminRunnerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationAdminRunnerPath(gon.current_organization.path, ...args);
  }

  return _newAdminRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners/:id/edit(.:format)`
 * - Path helper: `edit_admin_runner_path`
 * - URL helper: `edit_admin_runner_url`
 * - controller#action: `admin/runners#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminRunnerPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationAdminRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editAdminRunnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationAdminRunnerPath(gon.current_organization.path, ...args);
  }

  return _editAdminRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/runners/:id(.:format)`
 * - Path helper: `admin_runner_path`
 * - URL helper: `admin_runner_url`
 * - controller#action: `admin/runners#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRunnerPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminRunnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminRunnerPath(gon.current_organization.path, ...args);
  }

  return _adminRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/jobs/cancel_all(.:format)`
 * - Path helper: `cancel_all_admin_jobs_path`
 * - URL helper: `cancel_all_admin_jobs_url`
 * - controller#action: `admin/jobs#cancel_all`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelAllAdminJobsPath = /*#__PURE__*/ (...args) => {
  const _cancelAllOrganizationAdminJobsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"cancel_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _cancelAllAdminJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"cancel_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _cancelAllOrganizationAdminJobsPath(gon.current_organization.path, ...args);
  }

  return _cancelAllAdminJobsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/jobs(.:format)`
 * - Path helper: `admin_jobs_path`
 * - URL helper: `admin_jobs_url`
 * - controller#action: `admin/jobs#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminJobsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminJobsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminJobsPath(gon.current_organization.path, ...args);
  }

  return _adminJobsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/ci/variables(.:format)`
 * - Path helper: `admin_ci_variables_path`
 * - URL helper: `admin_ci_variables_url`
 * - controller#action: `admin/ci/variables#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCiVariablesPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminCiVariablesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"variables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminCiVariablesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"variables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminCiVariablesPath(gon.current_organization.path, ...args);
  }

  return _adminCiVariablesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/dashboard/stats(.:format)`
 * - Path helper: `admin_dashboard_stats_path`
 * - URL helper: `admin_dashboard_stats_url`
 * - controller#action: `admin/dashboard#stats`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDashboardStatsPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminDashboardStatsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _adminDashboardStatsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminDashboardStatsPath(gon.current_organization.path, ...args);
  }

  return _adminDashboardStatsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/organization(.:format)`
 * - Path helper: `admin_organization_dashboard_path`
 * - URL helper: `admin_organization_dashboard_url`
 * - controller#action: `admin/organizations/dashboard#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationDashboardPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _adminOrganizationDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin(.:format)`
 * - Path helper: `admin_root_path`
 * - URL helper: `admin_root_url`
 * - controller#action: `admin/dashboard#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRootPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminRootPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _adminRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminRootPath(gon.current_organization.path, ...args);
  }

  return _adminRootPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/version_check(.:format)`
 * - Path helper: `admin_version_check_path`
 * - URL helper: `admin_version_check_url`
 * - controller#action: `admin/version_check#version_check`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVersionCheckPath = /*#__PURE__*/ (...args) => {
  const _organizationAdminVersionCheckPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"version_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _adminVersionCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"version_check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAdminVersionCheckPath(gon.current_organization.path, ...args);
  }

  return _adminVersionCheckPath(...args);
};

